module.exports = __webpack_public_path__ + "6e64e1945ba388d95cb7534f4d42e483.pdf";